let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("abYVj")).then(() => parcelRequire('4USHK'));